import React, { useEffect, useMemo, useState } from "react";
import ReactSwitch from "react-switch";
import { Divider } from "primereact/divider";
import {
  APP_CONSTANT,
  BASE_SIZE_MIN_VALUE,
  getAppConstantCategoryValue,
  INDEX_SCORE_INDICATOR,
} from "../../../../utils/constants";
import DataTableSkeleton from "../../../Skeletons/DataTableSkeleton";
import { toSentenceCase } from "../../../../utils/constants";
import { sampleSizeSymbolCheck } from "../../../../utils/commonLogics";
import { useGlobalContext } from "../../../../context/GlobalContext";

const OccasionAndNeedTable = ({
  tableData,
  question,
  headerText,
  subTitle,
  indexChecked,
  handleIndexToggle,
  loading = false,
  headerSubTitle = "",
  hideShowIndex,
}) => {
  const { isCustomRecruitCategory } = useGlobalContext();
  const [headers, setHeaders] = useState([]);
  const [headersNValue, setHeadersNValue] = useState([]);
  const [sortField, setSortField] = useState(
    getAppConstantCategoryValue(isCustomRecruitCategory)?.toUpperCase(),
  );
  const [sortOrder, setSortOrder] = useState("desc");

  useEffect(() => {
    if (tableData?.datasets && tableData?.datasets.length) {
      if (indexChecked) {
        let tableWithIndexColumn = tableData.datasets;
        tableWithIndexColumn = tableWithIndexColumn.flatMap(
          (dataset, index) => {
            const newItems = [dataset];

            if (index > 0 && index < tableData.datasets.length) {
              newItems.push({
                label: "Index",
                data: dataset.index,
              });
            }

            return newItems;
          },
        );

        const tableColumnNValue = [
          "",
          ...tableWithIndexColumn.map((dataset) =>
            dataset.label.toUpperCase() !== "INDEX"
              ? dataset?.total_response
              : "",
          ),
        ];

        tableWithIndexColumn = [
          "",
          ...tableWithIndexColumn.map((dataset) => dataset.label.toUpperCase()),
        ];
        setHeaders(tableWithIndexColumn);
        setHeadersNValue(tableColumnNValue);
      } else {
        let tableWithIndexColumn = tableData.datasets;
        const tableColumnNValue = [
          "",
          ...tableWithIndexColumn.map((dataset) => dataset?.total_response),
        ];
        tableWithIndexColumn = [
          "",
          ...tableWithIndexColumn.map((dataset) => dataset.label.toUpperCase()),
        ];
        setHeaders(tableWithIndexColumn);
        setHeadersNValue(tableColumnNValue);
      }
    }
  }, [tableData?.datasets, indexChecked]);

  const transformedData = useMemo(() => {
    if (tableData?.labels?.length) {
      let processTransformedData = tableData?.labels
        .map((label, index) => {
          const row = { rowHeader: label };
          const categoryDataset = tableData.datasets.find(
            (dataset) =>
              dataset.label.toUpperCase() ===
              getAppConstantCategoryValue(
                isCustomRecruitCategory,
              ).toUpperCase(),
          );
          tableData.datasets.forEach((dataset, i) => {
            const originalValue = dataset.data[index];
            const categoryValue = categoryDataset?.data[index] || 1;
            const ratio = (originalValue / categoryValue) * 100;
            row[dataset.label] = {
              value: originalValue,
              // className:
              //   dataset.label.toUpperCase() === "CATEGORY"
              //     ? "text-secondary fw-bold"
              //     : ratio >= INDEX_SCORE_INDICATOR.GREEN_TEXT_VALUE
              //       ? "text-success fw-bold"
              //       : ratio >= INDEX_SCORE_INDICATOR.GREY_TEXT_MIN_VALUE &&
              //           ratio <= INDEX_SCORE_INDICATOR.GREY_TEXT_MAX_VALUE
              //         ? "text-secondary fw-bold"
              //         : "text-danger fw-bold",
              className: "text-secondary fw-bold",
              indexVal: Math.round(ratio),
            };
          });
          let allZeroValues = false;
          if (
            row.rowHeader !== "None of the above" &&
            row?.rowHeader !== "Other"
          ) {
            allZeroValues = Object.entries(row)
              .filter(
                ([key, val]) =>
                  typeof val === "object" && val.hasOwnProperty("value"),
              )
              .every(([_, val]) => val.value === 0);
          }

          return allZeroValues ? "" : row;
        })
        .filter((data) => data !== "");

      if (!sortField || !sortOrder) {
        return processTransformedData;
      }

      // processTransformedData = processTransformedData.filter((transformedData) => {
      //   if(transformedData.rowHeader === "None of the above" && ) {
      //     return true;
      //   }
      // });

      const data = [...processTransformedData];

      for (let i = 0; i < tableData?.datasets.length; i++) {
        if (
          sortField.toUpperCase() ===
          tableData?.datasets[i].label?.toUpperCase()
        ) {
          data.sort((a, b) => {
            const nameA = a[tableData?.datasets[i].label]?.value || "";
            const nameB = b[tableData?.datasets[i].label]?.value || "";
            if (nameA < nameB) return sortOrder === "asc" ? -1 : 1;
            if (nameA > nameB) return sortOrder === "asc" ? 1 : -1;
            return 0;
          });
        }
      }
      return data;
    }
  }, [tableData?.datasets, sortField, sortOrder]);

  const handleSort = (field) => {
    if (sortField === field) {
      // If already sorting on this field, toggle the order
      let newSortOrder = "";
      if (sortOrder === "") {
        newSortOrder = "asc";
      } else if (sortOrder === "asc") {
        newSortOrder = "desc";
      } else {
        newSortOrder = "";
      }
      setSortOrder(newSortOrder);
    } else {
      // New sort field selected, set sort order ascending by default
      setSortField(field);
      setSortOrder("desc");
    }
  };

  if (!tableData?.labels || !tableData?.datasets) return null;

  return (
    <div className="mt-4" style={{ maxWidth: "100%" }}>
      <div className="mb-4">
        <h5 className="fw-bold mb-2 text-start">{headerText}</h5>
        {/* <h6 className="fw-bold mb-2 text-start">{headerSubTitle}</h6> */}
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ color: "#6c757d" }}
        >
          <div className="text-start fw-bold fs-12 pb-3">{subTitle}</div>
          {!hideShowIndex ? (
            <div className="text-start fw-bold fs-12 pb-3 d-flex align-items-center">
              <div className="me-2">Hide Index</div>
              <div className="me-2">
                <ReactSwitch
                  checked={indexChecked}
                  onChange={handleIndexToggle}
                  offColor="#ced4da"
                  onColor="#ced4da"
                  offHandleColor="#fff"
                  onHandleColor="#ff9800"
                  height={24}
                  width={50}
                  handleDiameter={18}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0 2px 4px rgba(0, 0, 0, 0.2)"
                />
              </div>
              <div className="">Show Index</div>
            </div>
          ) : (
            ""
          )}
        </div>
        {loading ? (
          <DataTableSkeleton />
        ) : (
          <>
            <div className="table-responsive">
              <table
                className="table text-center"
                style={{
                  minWidth: "600px",
                  tableLayout: "auto",
                  fontSize: "15px",
                }}
              >
                <thead className="thead-light">
                  <tr style={{ borderBottom: "1px solid #dee2e6" }}>
                    {headers.map((header, index) => (
                      <th
                        key={index}
                        style={{
                          color: "#6c757d",
                          // position: index === 0 ? "sticky" : "static",
                          left: index === 0 ? 0 : "auto",
                          background: "#fff",
                          zIndex: index === 0 ? 2 : "auto",
                          width: index === 0 ? "250px" : "auto",
                          minWidth: index === 0 ? "250px" : "auto",
                          cursor: "pointer",
                          borderLeft:
                            index !== 0 && index !== 1 && header !== "INDEX"
                              ? "1px solid #002133"
                              : "",
                          borderRight:
                            header === "INDEX" ? "1px solid #002133" : "",
                        }}
                        onClick={() => handleSort(header)}
                      >
                        <div className="d-flex align-items-start justify-content-center">
                          <div
                            className="header-name"
                            style={{
                              color:
                                index !== 0 &&
                                header !== "INDEX" &&
                                headersNValue[index] < BASE_SIZE_MIN_VALUE
                                  ? "#6c757d" // previous color #dc3545(red)
                                  : "#6c757d",
                            }}
                          >
                            {toSentenceCase(header)}
                            <br />
                            {index !== 0 && header !== "INDEX" ? (
                              <>
                                (n={headersNValue[index]} XMOT<sup>&reg;</sup>{" "}
                                surveys)
                                {sampleSizeSymbolCheck(
                                  headersNValue[index],
                                  "survey",
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="sorting-icons ms-1">
                            {index !== 0 && header.toUpperCase() !== "INDEX" ? (
                              sortField === header ? (
                                sortOrder === "asc" ? (
                                  <span className="pi pi-sort-amount-down"></span>
                                ) : sortOrder === "desc" ? (
                                  <span className="pi pi-sort-amount-up"></span>
                                ) : (
                                  <span className="pi pi-sort-alt"></span>
                                )
                              ) : (
                                <span className="pi pi-sort-alt"></span>
                              )
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {transformedData.map((row, index) => (
                    <tr className="table-row" key={index}>
                      <td
                        className="fw-bold text-start"
                        style={{
                          color: "#4A5057",
                          // position: "sticky",
                          left: 0,
                          background: "#fff",
                          zIndex: 2,
                        }}
                      >
                        {row.rowHeader}
                      </td>
                      {tableData.datasets.map((dataset, dindex) => {
                        const ratio = row[dataset.label]?.indexVal || 0;
                        // dataset?.index && dataset?.index.length
                        //   ? dataset?.index[index]
                        //   : 0;
                        return (
                          <React.Fragment key={dindex}>
                            <td
                              className={row[dataset.label].className}
                              style={{
                                borderLeft:
                                  dindex !== 0 ? "1px solid #002133" : "",
                              }}
                            >
                              {`${row[dataset.label].value}%`}
                            </td>
                            {dindex > 0 && indexChecked && (
                              <td
                                className={
                                  ratio > INDEX_SCORE_INDICATOR.GREEN_TEXT_VALUE
                                    ? "text-success fw-bold"
                                    : ratio >=
                                          INDEX_SCORE_INDICATOR.GREY_TEXT_MIN_VALUE &&
                                        ratio <=
                                          INDEX_SCORE_INDICATOR.GREY_TEXT_MAX_VALUE
                                      ? "text-secondary fw-bold"
                                      : "text-danger fw-bold"
                                }
                                style={{
                                  borderRight: "1px solid #002133",
                                  backgroundColor: "rgb(241 242 242)",
                                }}
                              >
                                {/* {dataset?.index && dataset?.index.length
                                  ? dataset?.index[index]
                                  : 0} */}
                                {ratio}
                              </td>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p
              style={{ width: "95%" }}
              className="p-2 mt-4 fs-12 text-start rounded-2 fw-bold border text-secondary"
            >
              {question}
            </p>
          </>
        )}
        <Divider />
      </div>
    </div>
  );
};

export default OccasionAndNeedTable;
